import StepConnector, {
    stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from '@mui/material/styles';


export const CustomisedConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            height: 2,
            backgroundColor: theme.palette.secondary.main,
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            height: 2,
            backgroundColor: theme.palette.secondary.main,
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 1,
        border: theme.size[10],
        backgroundColor: "lightgray",
        borderRadius: 1,
    },
}));